module.exports = "/legacy/bcd34b6aa3516d4e6a0425b1548af672.svg";